import { IContext, teamsSdk } from '../teams-sdk/teamsSdk';

export const getTeamsContext = (
  onGetTeamsContext: (context: IContext) => void
) => {
  teamsSdk.getContext(onGetTeamsContext);
};

export const getTeamsContextAsPromise = (): Promise<IContext> => {
  return new Promise<IContext>(resolve => {
    teamsSdk.getContext((context: IContext) => {
      resolve(context);
    });
  });
};
